import { FormControl, FormLabel, FormGroup, Checkbox, FormControlLabel, FormHelperText } from '@material-ui/core';
import { getIn } from 'formik';
import React from 'react';
import { Hint } from 'v2/components/Shared/Hint';

import type { FieldProps } from 'formik';

interface IOption {
  label: string;
  value: string;
}

interface IProps extends FieldProps {
  label?: string;
  formStyle?: any;
  formControlStyle?: any;
  options: IOption[];
}

export const ListCheckboxFormField = ({ field, form, label, options, formStyle, formControlStyle }: IProps) => {
  const errorText = getIn(form.errors, field.name);
  return (
    <FormControl fullWidth error={!!errorText}>
      <Hint inputName={field.name}>
        <FormLabel component='legend'>{label}</FormLabel>
        <FormGroup style={formStyle}>
          {options.map((op) => {
            const checked = (field.value || []).find((item: any) => item === op.value) || false;
            const handleChange = () => {
              let newValues: any[] = [];
              const alreadyHas = (field.value || []).find((item: any) => item === op.value);
              if (alreadyHas) {
                newValues = (field.value || []).filter((item: any) => item !== op.value);
              } else {
                newValues = (field.value || []).concat([op.value]);
              }
              form.setFieldValue(field.name, newValues);
            };
            return (
              <FormControlLabel
                style={formControlStyle}
                key={op.value}
                control={<Checkbox checked={checked} onChange={handleChange} value={op.value} />}
                label={op.label}
              />
            );
          })}
        </FormGroup>
      </Hint>
      {errorText && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  );
};
